export default __webpack_public_path__ + "static/media/incinerate.a55225f6.png";